"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservableCreate = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const _1 = require(".");
/**
 * Wrapper for rxjs Observable.create with improved error handling and
 * aborting support
 * @param func - observer function, could be async
 */
function ObservableCreate(func, signal) {
    return rxjs_1.Observable.create((observer) => {
        try {
            const ret = func(observer);
            // catch async errors
            if (ret && ret.catch) {
                ret.catch(error => observer.error(error));
            }
        }
        catch (error) {
            // catch sync errors
            observer.error(error);
        }
    }).pipe((0, operators_1.takeUntil)((0, _1.observeAbortSignal)(signal)));
}
exports.ObservableCreate = ObservableCreate;
